import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import './StatusProgressBar.css';


class StatusProgressBar extends Component {
  render() {
    const { options, progress } = this.props;
    let isActive;
    return (
      <Row>
        <Col className="mt-2 mb-2 wrapper" >
          <div className="arrow-steps">
            { options.map((option, index) => {
              const backgroundColor = isActive ? '#82ad42' : '#dc7143';
              isActive = !isActive ? option.value === progress : isActive;
              return (
                <div
                  key={`progress_key_${option.value}_${index}`}
                  style={{
                    '--background-color': backgroundColor,
                    '--border-color': backgroundColor,
                    'margin': "2"
                  }}
                className="step"
                >
                  <span>{option.label}</span>
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    );
  }

}

export default StatusProgressBar;
